import { Injectable } from '@angular/core';
import { WrapperService } from '../wrapper/wrapper.service';

@Injectable({
  providedIn: 'root',
})
export class FHService {
  constructor(private wrapperService: WrapperService) {}

  fhSearch(params: any) {
    let apiOptions: any = {
      name: 'fh',
      suffix: '/search',
      method: 'GET',
      oParam: {
        q: params?.q,
        pageNum: params?.pageNum,
        pageSize: params?.pageSize,
        orderBy: params?.sort,
        ascending: 'asc',
        searchType: 'general',
      },
    };
    if (params?.mode !== '') {
      apiOptions.oParam['mode'] = params?.mode;
    }
    if (params?.emailDomain !== '') {
      apiOptions.oParam['emailDomain'] = params?.emailDomain;
    }
    if (params?.levels !== null) apiOptions.oParam['levels'] = params?.levels;
    if (params?.status.length === 1) apiOptions.oParam['status'] = params?.status[0];
    if (params?.orgType && params?.orgType.length > 0) apiOptions.oParam['orgType'] = params?.orgType.join(',');
    if (params?.isNameSearchType) apiOptions.oParam['searchType'] = 'name';
    if (params?.isCode) apiOptions.oParam['searchType'] = 'code';
    if (params?.isDefaultDept) apiOptions.oParam['defaultDept'] = 'true';
    if (params?.depth !== 0) apiOptions.oParam['depth'] = params?.depth;
    if (params?.exclusive !== null) apiOptions.oParam['exclusive'] = params?.exclusive;
    if (params?.defaultRoles) {
      apiOptions.oParam['defaultRoles'] = true;
    }
    if (params?.adminHierarchy) {
      apiOptions.oParam['adminHierarchy'] = true;
      apiOptions.oParam['defaultRoles'] = false;
    }
    if (params?.adminRolesHierarchy) {
      apiOptions.oParam['adminRolesHierarchy'] = params?.adminRolesHierarchy;
    }
    return this.wrapperService.call(apiOptions, true);
  }
}
